import { Card } from "@/src/components/shad/card";
import TFAApp from "./components/TFAApp";
const TwoFactor = () => {

  return (
    <Card>
      <TFAApp />
    </Card>
  );
};

export default TwoFactor;
